export default __webpack_public_path__ + "static/media/404.ee39addb.svg";